<template>
  <customModal :containersm="true" @closeModal="closeModal">

    <!-- TITLE -->
    <template #title>
      Export File
    </template>

    <!-- BODY -->
    <template #body>

      <div class="row">

        <!-- Export Type -->
        <div class="col-lg-12 mb-3">

          <label class="col-form-label">
            Export File Type
            <sup>
              <i class="fa fa-asterisk required"></i>
            </sup>
          </label>

          <select
            class="form-control"
            v-model="selectedExportType"
          >
            <option value="" disabled>
              Select 
            </option>

            <option value="E2B_SAE">
              E2B(R3) (XML)
            </option>

            <option value="AE">
              AE (CSV)
            </option>

            <option value="SAE">
              SAE (CSV)
            </option>

            <option value="SUSAR">
              SUSAR (CSV)
            </option>

          </select>

          <small
            class="errorClass"
            v-if="formErrors.selectedExportType"
          >
            {{ formErrors.selectedExportType }}
          </small>

        </div>

      </div>

      <!-- ACTION -->
      <div class="text-end mt-3">

      <button
    class="save_btn px-4 py-1"
    @click="submitExport"
    :disabled="loader"
>
    <span v-if="loader">
        <i class="fa fa-spinner fa-spin mr-1"></i>
        Exporting...
    </span>

    <span v-else>
        Export
    </span>
</button>

      </div>

    </template>

  </customModal>
</template>

<script src="./AeExportModal.js"></script>